export const SET_COOKIES = 'SET_COOKIES'

export const COOKIE_TYPE_PREFERENCE = 'visitPreferences'
export const COOKIE_TYPE_ANALYTICS = 'analytics'
